export default __webpack_public_path__ + "static/media/rifles-1.7b0f3016.svg";